import { all, create } from "mathjs"

const config = {}
const math = create(all, config)

export default math
